"use strict";
const options_collection = {
  collectionsLoadMore: ".collections-load-more",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionSidebar: "#CollectionSidebar",
  collectionFilterBlocks: ".filter-blocks",
  productgridcontainer: "#productgridcontainer",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.addEventListener("click", this.onOpen.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
    document.addEventListener("keydown", this.onDocumentKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onOpen();
    }
  }
  onDocumentKeydown(event) {
    if (!this.collectionSidebar?.classList.contains("open")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      eventCollectionShopify.cancelStagedFilters();
      eventCollectionShopify.closeFilterDrawer();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = Array.from(
      this.collectionSidebar.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
  onOpen() {
    if (!this.classList.contains("open")) {
      eventCollectionShopify.captureStagedFilterBaseline();
      this.collectionSidebar.classList.add("open");
      this.collectionSidebar.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("open-drawer", "open-sidebar");
      root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
      this.classList.add("open");
      this.setAttribute("aria-expanded", "true");
      requestAnimationFrame(() => {
        this.collectionSidebar.querySelector("close-filter")?.focus();
      });
    } else {
      eventCollectionShopify.cancelStagedFilters();
      this.collectionSidebar.classList.remove("open");
      this.collectionSidebar.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("open-drawer", "open-sidebar");
      root.style.removeProperty("padding-right");
      this.classList.remove("open");
      this.setAttribute("aria-expanded", "false");
      this.focus();
    }
  }
}
customElements.define("btn-filter", BtnFilter);

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.addEventListener("click", this.onClose.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onClose();
    }
  }
  onClose() {
    eventCollectionShopify.cancelStagedFilters();
    eventCollectionShopify.closeFilterDrawer();
  }
}
customElements.define("close-filter", CloseFilter);

class FacetApplyCanvas extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onApply.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onApply();
    }
  }
  onApply() {
    eventCollectionShopify.applyStagedFilters();
    eventCollectionShopify.closeFilterDrawer();
  }
}
customElements.define("facet-apply-canvas", FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.gridMode.bind(this), false);
  }
  gridMode() {
    const view_mode = this.getAttribute("data-grid-mode");
    if (this.classList.contains("active")) return;
    if (view_mode == 1) return;
    for (var item of document.querySelectorAll("grid-mode")) {
      item.classList.remove("active");
    }
    const container_switch = document.querySelector(
      ".container-products-switch"
    );
    this.classList.add("active");
    const data_view_mode = container_switch.getAttribute("data-view-mode");
    container_switch.classList.remove("grid-columns-" + data_view_mode);
    container_switch.setAttribute("data-view-mode", view_mode);
    container_switch.classList.add("grid-columns-" + view_mode);
  }
}
customElements.define("grid-mode", GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute("data-view");
    if (this.classList.contains("actived")) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("view", queryString);
    if (view_mode == "list") {
      var searchParams = queryString.replace("?", "") + "&view=list";
    } else {
      var searchParams = queryString.replace("?", "") + "&view=grid";
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("view-mode", ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    const checkbox = this.querySelector(".checkbox");
    const disabled = this.classList.contains("pointer-none") || this.closest("li")?.classList.contains("disabled");
    this.setAttribute("role", checkbox ? "checkbox" : "button");
    if (checkbox) {
      this.setAttribute("aria-checked", String(checkbox.classList.contains("checked")));
    }
    this.setAttribute("aria-disabled", String(Boolean(disabled)));
    if (!disabled) this.setAttribute("tabindex", "0");
    this.addEventListener("click", this.filterItem.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.filterItem();
    }
  }
  filterItem() {
    if (this.getAttribute("aria-disabled") === "true") return;
    if (this.querySelector(".tooltip")) {
      this.querySelector(".tooltip").classList.toggle("current-filter");
    } else if (this.closest("li")) {
      this.closest("li").classList.toggle("current-filter");
    }
    if (this.getAttribute("role") === "checkbox") {
      this.setAttribute("aria-checked", String(this.getAttribute("aria-checked") !== "true"));
    }
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define("filter-item", FilterItem);

class FacetClearAll extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute("data-href");
    const shouldStage = eventCollectionShopify.shouldStageFilters();
    eventCollectionShopify.renderSectionFilter(url);
    if (!shouldStage) {
      eventCollectionShopify.closeFilterDrawer();
    }
  }
}
customElements.define("facet-clear-all", FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterSort.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.filterSort();
    }
  }
  filterSort() {
    this.closest(".select-custom")?.classList.remove("active");
    document.documentElement.classList.remove("open-sort-sheet");
    const value = this.getAttribute("value");
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("sort_by", queryString);
    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("filter-sort", FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
    this.addEventListener("keydown", this.onKeydown.bind(this), false);
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.activeFilterSort();
    }
  }
  activeFilterSort() {
    const select = this.closest(".select-custom");
    const willOpen = !select.classList.contains("active");
    select.classList.toggle("active", willOpen);
    this.setAttribute("aria-expanded", String(willOpen));
    document.documentElement.classList.toggle("open-sort-sheet", willOpen);
  }
}
customElements.define("select-sorter", SelectSorter);

var eventCollectionShopify = (function () {
  const stagedFilters = {
    responseText: null,
    url: null,
    searchParams: false,
    originalFilterBlocks: null,
    originalActionMarkup: null,
  };

  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector(".horizontal-filter");
        if (horizontal) {
          const collapsible = document.querySelectorAll("collapsible-block");
          collapsible.forEach((e) => {
            e.classList.add("active");
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector(".price-range");
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector(".min-price-range");
      const maxPrice = document.querySelector(".max-price-range");
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      document
        .querySelector(options_collection.minPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(minRange.min) + Number(target.value) >= 0) {
              if (Number(target.value) > Number(maxRange.max)) {
                minPrice.value = Number(maxRange.max);
              } else {
                minPrice.value = Number(target.value);
              }
            } else {
              minPrice.value = Number(minRange.min);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.maxPriceRange)
        .addEventListener(
          "change",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            target.value = target.value.replace(',','')
            if (Number(maxRange.max) - Number(target.value) >= 0) {
              maxPrice.value = Number(target.value);
            } else {
              maxPrice.value = Number(maxRange.max);
            }
            const formData = new FormData(
              document.querySelector(options_collection.collectionFiltersForm)
            );
            const params = new URLSearchParams(formData).toString();
            const nameMin = minPrice.getAttribute("name");
            const nameMax = maxPrice.getAttribute("name");
            var queryString = window.location.search;
            queryString = this.removeParam(nameMin, queryString);
            queryString = this.removeParam(nameMax, queryString);
            var searchParams = queryString.replace("?", "") + "&" + params;
            const url = this.renderUrl(searchParams);
            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .min").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-from",
                (minRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          "input",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector(".price-lable .max").innerHTML =
              price_format;
            target
              .closest(".price-range")
              .style.setProperty(
                "--range-to",
                (maxRange.value / Number(target.getAttribute("max"))) * 100 +
                  "%"
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            "change",
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute("name");
              const nameMax = maxPrice.getAttribute("name");
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace("?", "") + "&" + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      const shouldStage = this.shouldStageFilters();
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (shouldStage) {
            this.stageFilterResponse(responseText, url, searchParams);
          } else if (window.innerWidth <= 1024) {
            const responseDocument = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const collectionFilterBlocks = responseDocument.querySelector(
              options_collection.collectionFilterBlocks
            );
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = responseDocument.querySelector(
              options_collection.productgridcontainer
            );
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains("open")
            ) {
              const filterButton = document.querySelector(".btn-filter");
              filterButton?.classList.add("open");
              filterButton?.setAttribute("aria-expanded", "true");
            }
            this.updateUrl(url, searchParams);
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
            this.updateUrl(url, searchParams);
          }
          document.documentElement.classList.remove("hside_opened");
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          initLazyloadItem();
          eventCollectionShopify.ionRangeSlider();
        });
    },

    shouldStageFilters: function () {
      const sidebar = document.querySelector(options_collection.collectionSidebar);
      return window.innerWidth <= 1024 && sidebar?.classList.contains("open");
    },

    captureStagedFilterBaseline: function () {
      if (
        window.innerWidth > 1024 ||
        stagedFilters.originalFilterBlocks !== null
      ) {
        return;
      }

      const currentBlocks = document.querySelector(
        options_collection.collectionFilterBlocks
      );
      const currentAction = document.querySelector(".filter-action-bottom");
      stagedFilters.originalFilterBlocks = currentBlocks?.innerHTML || "";
      stagedFilters.originalActionMarkup = currentAction?.innerHTML || "";
    },

    stageFilterResponse: function (responseText, url, searchParams) {
      const responseDocument = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );
      const currentBlocks = document.querySelector(
        options_collection.collectionFilterBlocks
      );
      const nextBlocks = responseDocument.querySelector(
        options_collection.collectionFilterBlocks
      );
      const currentAction = document.querySelector(".filter-action-bottom");
      const nextAction = responseDocument.querySelector(".filter-action-bottom");

      this.captureStagedFilterBaseline();

      if (currentBlocks && nextBlocks) {
        currentBlocks.innerHTML = nextBlocks.innerHTML;
      }
      if (currentAction && nextAction) {
        currentAction.className = nextAction.className;
        currentAction.innerHTML = nextAction.innerHTML;
      }

      stagedFilters.responseText = responseText;
      stagedFilters.url = url;
      stagedFilters.searchParams = searchParams;

      const filterButton = document.querySelector(".btn-filter");
      filterButton?.classList.add("open");
      filterButton?.setAttribute("aria-expanded", "true");
    },

    applyStagedFilters: function () {
      if (!stagedFilters.responseText) return;

      const responseDocument = new DOMParser().parseFromString(
        stagedFilters.responseText,
        "text/html"
      );
      const nextGrid = responseDocument.querySelector(
        options_collection.productgridcontainer
      );
      const currentGrid = document.querySelector(
        options_collection.productgridcontainer
      );

      if (currentGrid && nextGrid) {
        currentGrid.innerHTML = nextGrid.innerHTML;
      }
      this.updateUrl(stagedFilters.url, stagedFilters.searchParams);
      this.resetStagedFilterState();
      initLazyloadItem();
    },

    cancelStagedFilters: function () {
      if (stagedFilters.originalFilterBlocks === null) return;

      const currentBlocks = document.querySelector(
        options_collection.collectionFilterBlocks
      );
      const currentAction = document.querySelector(".filter-action-bottom");
      if (stagedFilters.responseText && currentBlocks) {
        currentBlocks.innerHTML = stagedFilters.originalFilterBlocks;
      }
      if (stagedFilters.responseText && currentAction) {
        currentAction.innerHTML = stagedFilters.originalActionMarkup;
        currentAction.classList.toggle(
          "has-active-filters",
          Boolean(currentAction.querySelector("facet-clear-all"))
        );
      }
      this.resetStagedFilterState();
      this.ionRangeSlider();
    },

    resetStagedFilterState: function () {
      stagedFilters.responseText = null;
      stagedFilters.url = null;
      stagedFilters.searchParams = false;
      stagedFilters.originalFilterBlocks = null;
      stagedFilters.originalActionMarkup = null;
    },

    closeFilterDrawer: function () {
      const opener = document.querySelector(".btn-filter.open");
      const sidebar = document.querySelector(options_collection.collectionSidebar);
      sidebar?.classList.remove("open");
      sidebar?.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("open-drawer", "open-sidebar");
      document.querySelectorAll(".btn-filter").forEach((button) => {
        button.classList.remove("open");
        button.setAttribute("aria-expanded", "false");
      });
      root.style.removeProperty("padding-right");
      opener?.focus();
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add("start", "loading");
        } else {
          event.classList.add("finish");
          setTimeout(function () {
            event.classList.remove("start", "loading", "finish");
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else {
        window.history.pushState({ url: url }, "", url);
      }
    },
  };
})();
eventCollectionShopify.init();
